import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchPurInwardData } from '../../Store/PHPSlice/Inward/PurchaseInward';
import { selectPIData } from '../Selectors/Master/ItemSelectors';
import { Grid, Paper } from '@mui/material';
import { BallotOutlined } from '@mui/icons-material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';
import ReactToPrint from 'react-to-print';

const PIView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({});
    const [purData, setPurData] = useState([]);
    const pidata = useSelector(selectPIData);
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        dispatch(fetchPurInwardData(Id));
    }, []);

    useEffect(() => {
        if (pidata.data) {
            const data = pidata.data;
            setFormData(data);
            const arr = data?.cloth_data;
            setPurData(arr);
        }

    }, [pidata])

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/BaleLumpView?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    const tableContainerStyle = {
        marginLeft: isDesktop ? '2%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    console.log(pidata);
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Purchase Inward Cloth View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ fontSize: '15px', margin: '2%' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.date}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>PI No.</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.pInNo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>PO No.</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.pono}</td>
                                    {/* <td style={{ width: '200px' }}>Firm</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }} className='light-color'>{formData.firmNm}</td> */}
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Total Mtr/KG</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totMtr}</td>
                                    <td style={{ width: '200px' }}>Bill No.</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.billNo}</td>
                                </tr>



                                {/* <tr>
                                    
                                    <td style={{ width: '200px' }}>Final Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.finalamt}</td>
                                </tr> */}

                                <tr>
                                    <td style={{ width: '200px' }}>LR Date</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.lrdt}</td>
                                    <td style={{ width: '200px' }}>LR No.</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.lrNo}</td>
                                </tr>
                                <tr>
                                    {/* <td style={{ width: '200px' }}>Total Qty</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totqty}</td> */}
                                    <td style={{ width: '200px' }}>Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totAmt}</td>
                                    <td style={{ width: '200px' }}>Tax Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.taxAmt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Final Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.finalAmt}</td>
                                    <td style={{ width: '200px' }}>Transport</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.transportNm}</td>

                                </tr>

                            </tbody>
                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Unit</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Mtr / KG</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                        {/* <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>IGST(%)</TableCell> */}
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                        {/* <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>CGST(%)</TableCell> */}
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                        {/* <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>SGST(%)</TableCell> */}
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total GST</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {purData?.map((row, index) => (
                                        <TableRow key={index}>

                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.clothNm}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.uom}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.deldt}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.rate}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.mtr}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.totamt}
                                            </TableCell>

                                            {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                                        {row.igst}
                                                                    </TableCell> */}
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.igstAmt}{" "}{`(${row.igst}%)`}
                                            </TableCell>
                                            {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                                        {row.cgst}
                                                                    </TableCell> */}
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.cgstAmt}{" "}{`(${row.cgst}%)`}
                                            </TableCell>
                                            {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                                        {row.sgst}
                                                                    </TableCell> */}
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.sgstAmt}{" "}{`(${row.sgst}%)`}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.gstamt}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                <button type='button' className="lump-btn" onClick={() => handleViewClick(row.bale_data)}> View</button>
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                        {/* {pidata?.data.length > 0 && (
                            pidata?.data?.map((val, valIndex) => (
                                <>
                                    <table style={{ margin: '1% 5%', fontSize: '15px' }} key={valIndex}>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: '200px' }}>Cloth:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{val.clothNm}</td>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Mtr.:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.mtr}</td>
                                            </tr>

                                            <tr>
                                                <td style={{ width: '200px' }}>Rate:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{val.rate}</td>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Amt:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.tot}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: '200px' }}>GST:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{val.GST}</td>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Net Amt.:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.netAmt}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: '200px' }}>Bale & Lump Details:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>
                                                    <button type='button' className="lump-btn" onClick={() => handleViewClick(val.bale)}> View</button>
                                                </td>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Net Amt.:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.netAmt}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table>
                                        <thead>
                                            <th>Sr.No.</th>
                                            <th>Bale</th>
                                            <th>Mtr.</th>
                                            <th>Rack</th>
                                            <th>Lump</th>
                                        </thead>
                                        <tbody>
                                            {val.bale.map((bal, balIndex) => (
                                                <tr key={balIndex}>
                                                    <td>{balIndex + 1}</td>
                                                    <td>{bal.bale}</td>
                                                    <td>{bal.mtr}</td>
                                                    <td>{bal.rack}</td>
                                                    <td>
                                                        <button type='button'>Lump</button>
                                                    </td>
                                                </tr>

                                            ))}
                                        </tbody>
                                    </table>

                                </>
                            ))

                        )} */}


                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
}

export default PIView;
